export default __webpack_public_path__ + "static/media/international-academy-entree-express.f3e76f5b.svg";